import { createSlotRecipe } from './runtime';

const cardConfig = {"name":"card","slots":["root","header","body","footer","title","description"],"variantMap":{"interactive":["true"]}}

export const card = /* @__PURE__ */ createSlotRecipe(cardConfig)